import { useHistory } from 'react-router-dom';
import { Card } from 'reactstrap';

import { PathsLayouts } from '../../../../config/routes';
import {
  ContinuousEducationFormDataLoaderProvider,
  useContinuousEducationFormDataLoader,
} from '../../loaders/ContinuousEducationLoader';
import { ContinuousEducationSectionForm } from './ContinuousEducationSectionForm';

const SectionsCreateContent = () => {
  const history = useHistory();
  const {
    result: formDataResult,
    loading,
    refresh,
  } = useContinuousEducationFormDataLoader();

  const handleBack = () => {
    history.push(`${PathsLayouts.continuousEducation}/sections`);
  };
  const handleCreated = (id: number) => {
    history.push(`${PathsLayouts.continuousEducation}/sections/${id}`);
  };

  return (
    <Card className="p-4 mt-2 mx-3">
      <ContinuousEducationSectionForm
        onCancel={handleBack}
        onSuccess={handleCreated}
        formData={formDataResult?.success ? formDataResult.data : undefined}
        loading={loading}
        error={formDataResult?.success ? undefined : formDataResult?.data}
        retry={refresh}
      />
    </Card>
  );
};

const SectionsCreate = () => {
  return (
    <ContinuousEducationFormDataLoaderProvider fetchImmediately>
      <SectionsCreateContent />
    </ContinuousEducationFormDataLoaderProvider>
  );
};

export default SectionsCreate;
